import { formatSecret } from "./encoding";
import type { NaclKeypair } from "./types";

// crypto_box is X25519 and nothing else, so there is no algorithm to pick and only the spelling is left to choose:
// 32 random bytes, and the point they take the curve's base to. Dynamic for the reason WireGuard's curve is.
export async function generateNaclKeypair(format: string): Promise<NaclKeypair> {
  const { x25519 } = await import("@noble/curves/ed25519.js");
  const { secretKey, publicKey } = x25519.keygen();
  return { secretKey: formatSecret(secretKey, format), publicKey: formatSecret(publicKey, format) };
}
